// extracted by mini-css-extract-plugin
export default {"actions":"OpportunityActionsCell_actions__DG2DL","actions__content":"OpportunityActionsCell_actions__content__+Gzym"};